import React from "react";
import { Link } from "react-router-dom";
import Tr from "./Tr";

// Site-wide footer — used ONLY at the bottom of the Home page (/).
// Carries the brand tagline, founder credit (Mr Givon Johnson), and
// the standard legal links.
//
// Feb 2026 (history): This footer used to be mounted globally inside
// App.js so it appeared on every route, but the user kept seeing the
// "Faith, but make it social." tagline and bio blurb flash in the
// background during scroll and route transitions. We removed it from
// the global mount and now render it exclusively at the bottom of
// /home, where it has the full hero context to belong to. Other
// pages (Bible, Sermons, Movies, etc.) intentionally have no footer.
export default function SiteFooter() {
  return (
    <footer
      className="mt-20 border-t border-cream-300 bg-cream-200/60 px-5 md:px-12 py-10 text-center md:text-left"
      data-testid="site-footer"
    >
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <div>
          <p className="font-heading text-2xl md:text-3xl text-forest font-medium leading-tight">
            <Tr>Faith,</Tr>{" "}
            <span className="italic text-terracotta"><Tr>but make it social.</Tr></span>
          </p>
          <p className="text-sm text-muted_ink mt-2 max-w-xl">
            <Tr>The first-faith social Bible app in 18 languages. Scripture aloud, gospel + faith based rap, Sunday sermons, faith films, kids' cartoons, and a whole community.</Tr>
          </p>
        </div>
        <div className="text-xs text-muted_ink space-y-2 md:text-right">
          <p>
            <span className="font-semibold text-forest">© Holy Words</span> · <Tr>Founded by</Tr>{" "}
            <span className="font-semibold text-forest">Mr Givon Johnson</span>
          </p>
          <nav className="flex flex-wrap gap-3 justify-center md:justify-end">
            <Link to="/about" data-testid="footer-about-link" className="hover:text-forest underline-offset-2 hover:underline"><Tr>About</Tr></Link>
            <span aria-hidden>·</span>
            <Link to="/support" data-testid="footer-support-link" className="hover:text-forest underline-offset-2 hover:underline"><Tr>Support</Tr></Link>
            <span aria-hidden>·</span>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-forest underline-offset-2 hover:underline"><Tr>Terms</Tr></Link>
            <span aria-hidden>·</span>
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-forest underline-offset-2 hover:underline"><Tr>Privacy</Tr></Link>
            <span aria-hidden="true">·</span>
            <Link to="/child-safety" data-testid="footer-child-safety-link" className="hover:text-forest underline-offset-2 hover:underline"><Tr>Child Safety</Tr></Link>
            <span aria-hidden>·</span>
            <Link to="/sms-terms" data-testid="footer-sms-terms-link" className="hover:text-forest underline-offset-2 hover:underline"><Tr>SMS Terms</Tr></Link>
            <span aria-hidden>·</span>
            <Link to="/acceptable-use" data-testid="footer-aup-link" className="hover:text-forest underline-offset-2 hover:underline"><Tr>Acceptable Use</Tr></Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
